export enum LocationType {
    PORT = 'port',
    PLACE = 'place',
}
